import React from "react";

import { memberStateToString } from '../../../Utils/Converters';

function MemberRow(props) {
    const { name, alias, memberState, godparent1Name, godparent1Alias, godparent2Alias, godparent2Name } = props;
    return (
        <tr key={name}>
            <td>{name}{alias === null ? null : <span> alias {alias}</span>}</td>
            <td>{memberStateToString(memberState)}</td>
            <td>{godparent1Name}{godparent1Alias === null ? null : <span> alias {godparent1Alias}</span>}</td>
            <td>{godparent2Name}{godparent2Alias === null ? null : <span> alias {godparent2Alias}</span>}</td>
        </tr>
    );
}

export default MemberRow;